import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover
} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { hasPermission } from 'helper/hasPermission';
import Confirmalertfordelete from '../../../ThemeComponents/confirmAlertForDelete';
import { adminLabels } from '../../../../redux/constant/admin-label-constant';
import { helperFunctions as HF } from 'helper/helperFunctions';
import { withRouter } from 'react-router-dom';
import { dataSyncActions } from '../../../../redux/actions/data-sync-actions';
var Modal = require('react-bootstrap-modal');

class BrandErrorMessagesListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addModal: false,
            editModal: false,
            sorted: '',
            filtered: '',
            pageSize: 10,
            errorsData: [],
            brand_data: {},
            params: [],
        };
        this.callEditlist = this.callEditlist.bind(this);
        this.deleteListItem = this.deleteListItem.bind(this);
        this.deleteConfirmListItem = this.deleteConfirmListItem.bind(this);
        this.filterSearchHandle = this.filterSearchHandle.bind(this);

    };

    filterSearchHandle(e) {
        this.setState({
            'filtered': e.target.value
        });
    }
    callEditlist(id) {
        this.props.getListItemCall(id).then(response => {
            this.setState({
                editModal: true
            });
        });
    }

    deleteListItem(list_id) {
        this.props.deleteListCall(list_id).then(response => {
            this.props.getListCall('listData', this.props.current_page, '', '', this.state.pageSize, 'listData', true);
        });
    }
    //
    deleteConfirmListItem(list_id) {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete typeName={this.props.name} description={"Are you sure to delete the" + this.props.name} onClosePro={onClose} deleteType={() => this.deleteListItem(list_id)} />
                )
            }
        })
    }

    listingPaginationData = (page, filter, sort, pageSize) => {
        this.setState({ pageSize: pageSize }, async function () {
            const res = await this.props.getErrorMessagesPaginatedCall(this.props.match.params.errorId, page, filter, sort, pageSize);
            this.setState({
                brand_data: res.result.brand_data
            })
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.errorsData !== this.props.errorsData) {
            this.setState({
                errorsData: this.props.errorsData
            })
        }
    }
    passParametersToModal = (e, data) => {
        this.setState({
            ...this.state,
            parameters: data,
            addModal: true,
        })
    }

    ConvertObjectToArray = (data) => {
        const newArray = []
        for (var key of Object.keys(data)) {
            if (key === 'brand_data_definition_id' || key === 'brand_id' || key === 'updated_at') {

            }
            else {
                // if (data[key] === 'null' || data[key] == '00') {

                // }
                newArray.push(key + " = " + data[key]);
            }
        }
        return newArray.map((param, index) => {
            return <div key={index}>
                {param}
            </div>
        })
    }

    render() {
        const { filtered, } = this.state;
        const { pages, loading, } = this.props;
        const columns = [
            {
                Header: <div className='text-capitalize'>List</div>,
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: 'Line No',
                        accessor: 'line_no',
                        width: 50,
                        className: "action-center",
                    },
                    {
                        Header: 'Message',
                        accessor: 'messages',
                        // minWidth: 400,
                        className: "action-center",
                        Cell: ({ value, original }) => (
                            <div>
                                {
                                    value.map((message, index) =>
                                        <span key={index}>
                                            {
                                                message
                                            }
                                            <br />
                                        </span>
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        Header: "Actions",
                        accessor: "id",
                        width: 150,
                        Cell: ({ value, original }) => (
                            <div >
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('manage-brand-lookup-tabeles') ? 'View Feed Data' : adminLabels.DONT_ALLOW}</Popover>}>
                                    <span>
                                        {
                                            hasPermission('manage-brand-lookup-tabeles') &&
                                            <button className="btn-primary btn" onClick={(e) => this.passParametersToModal(e, original.feed_data)}>Feed Data</button>
                                        }
                                        {
                                            !hasPermission('manage-brand-lookup-tabeles') &&
                                            <button className="btn-primary btn" onClick={(e) => this.passParametersToModal(e, original.feed_data)}>Feed Data</button>
                                        }
                                    </span>
                                </OverlayTrigger>
                            </div>
                        )
                    },
                ]
            }
        ];
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <h3 style={{ textAlign: 'center', fontWeight: "500" }}>{this.state.brand_data.brand || ''} Error Messages List</h3>
                                                    <h5 style={{ fontWeight: "500", marginTop: '20px' }}>File Path: {this.state.brand_data.file_path}</h5>
                                                </Col>

                                                <Col md={12} className="mt-xlg">
                                                    <ReactTable
                                                        noDataText='No data found'
                                                        data={this.props.errorMessagesList}
                                                        pages={pages}
                                                        loading={loading}
                                                        columns={columns}
                                                        filtered={filtered}
                                                        defaultPageSize={10}
                                                        className="-striped listing responsive"
                                                        pageData={this.listingPaginationData}
                                                        manual
                                                        onFetchData={(state, instance) => {
                                                            var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                                            state.pageData(state.page + 1, state.filtered, sort, state.pageSize);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Grid>
                                        {
                                            <Modal size='sm' className='custom_sm' show={this.state.addModal} onHide={HF.closeModal.bind(this, "addModal")} aria-labelledby="ModalHeader"
                                            >
                                                <Modal.Header closeButton>
                                                    <Modal.Title id='ModalHeader' className="headerTitle">Feed Data</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div >
                                                        <div >
                                                            {
                                                                this.state.parameters !== undefined &&
                                                                <span>
                                                                    {
                                                                        this.ConvertObjectToArray(this.state.parameters)
                                                                    }

                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                        }
                                    </div>
                                } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => {
    return ({
        getErrorMessagesPaginatedCall: (error_id, page, filter, sort, pageSize) => { return dispatch(dataSyncActions.getErrorMessagesPaginated(error_id, page, filter, sort, pageSize)) },
    });
};

function mapStateToProps(state, ownProps) {
    const { errorMessagesList, loading, pages, current_page,
    } = state.dataSyncReducer;

    return {
        loading, pages, current_page,
        errorMessagesList,
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandErrorMessagesListing));



// WEBPACK FOOTER //
// ./src/components/Admin/DataSync/SyncError/BrandErrorMessagesListing.jsx